import { createSearchEngine } from '../engine';

const QUERY_PARAM = 'q';

export const lycosSearch = createSearchEngine({
  safeParam: {
    key: 'adf',
    value: 'on',
  },
  isSearch: (url: URL): boolean => {
    return (
      /^(www\.)?search.*\.lycos\.[a-zA-Z0-9]+$/.test(url.hostname) &&
      /^\/web/.test(url.pathname) &&
      url.searchParams.has(QUERY_PARAM)
    );
  },
});
